require('./modifyLimitErrorStep.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const classNames = require('classnames');
// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
// @constants
const { BANK_PHONE_NUMBER_CLIENTS_ONLY_1,
        CARD_MODIFY_LIMIT_REJECTED_MESSAGE,
        CARD_MODIFY_LIMIT_OPERATION_ERROR_MESSAGE } = require('constants/index');

const ModifyLimitErrorStep = props => {
    const { immCard, immCardModifyLimit, url, buttonText } = props;
    const cardAlias = immCard.getIn(['alias', 'current']);
    const operationStatus = immCardModifyLimit.get('operationStatus');
    let iconBlock;
    let message;
    let serviceErrorMessage;
    let titleSubkey;

    if (operationStatus === CARD_MODIFY_LIMIT_REJECTED_MESSAGE) {
        titleSubkey = 'rejectedTitle';
        message = <FormattedText value="cardModifyLimitErrorStep-rejectedMessage" />
        iconBlock = (
            <div className="card-modify-limit-error__icons-block">
                <i className="card-modify-limit-error__icon icon-s-llamar"/>
                <p className="card-modify-limit-error__phone-number">{BANK_PHONE_NUMBER_CLIENTS_ONLY_1}</p>
                <i className="card-modify-limit-error__icon  card-modify-limit-error__icon--right-icon icon-s-llamar"/>
                <p className="card-modify-limit-error__phone-number">
                    <FormattedText value="cardModifyLimitErrorStep-phoneNumberClients" />
                </p>
            </div>
        );
    } else {
        const isPendingError = immCardModifyLimit.get('errorCode') === '410065'; // error different that there's already a card registration request being processed
        titleSubkey = 'errorTitle';

        if (!isPendingError) {
            message = <FormattedText value="cardModifyLimitErrorStep-errorMessage" />
        }

        if (operationStatus === CARD_MODIFY_LIMIT_OPERATION_ERROR_MESSAGE) {
            const serviceErrorClass = classNames({
                'card-modify-limit-error__service-error': !isPendingError
            });

            serviceErrorMessage = (
                <div className={serviceErrorClass}>
                    {immCardModifyLimit.get('operationErrorMessage')}
                </div>
            );
        }
    }

    const title = formatText(`cardModifyLimitErrorStep-${titleSubkey}`);

    const goBackButton = {
        label: buttonText || formatText('cards-backToCard', [cardAlias]).toUpperCase(),
        url: url
    };

    return (
        <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
            <WizardError
                errorMessage={title}
                mainButton={goBackButton}>
                <section className="row no-gutter">
                    <div className="col-xs-6 col-md-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                    </div>
                    <div className="col-xs-6 col-md-7">
                        {message}
                        {iconBlock}
                        {serviceErrorMessage}
                    </div>
                </section>
            </WizardError>
        </div>
    );
};

ModifyLimitErrorStep.propTypes = {
    immCard: PropTypes.object,
    immCardModifyLimit: PropTypes.object,
    url: PropTypes.string,
    buttonText: PropTypes.string
};

module.exports = ModifyLimitErrorStep;